import { AccordionItem } from '@chakra-ui/react';
import styled from 'styled-components';
import type { PTORequestItemLayout } from './PTORequestItem.component';

export const Item = styled(AccordionItem)`
  border: 0;

  &:last-of-type {
    > .chakra-collapse {
      border-radius: 0 0 8px 8px;
    }
  }

  & > .pto-request-item-accordion-button {
    padding: 0 !important;
  }

  & > .pto-request-item-accordion-button:hover {
    background-color: ${({ theme }) => theme.colors['neutral-20']};
    cursor: pointer;
    border-radius: 0;
  }

  &:not(&:last-of-type) {
    border-bottom: 1px solid ${(props) => props.theme.colors['neutral-30']};
  }

  &:hover,
  & > .chakra-accordion__button[aria-expanded='true'] {
    button {
      display: block;
    }
    span {
      display: inline;
    }
    .chakra-accordion__icon {
      color: ${(props) => props.theme.colors['primary-60']};
    }
  }
`;

export const ModalText = styled.p`
  font-size: 14px;
  line-height: 21px;
  color: ${({ theme }) => theme.colors['neutral-90']};
`;

export const Name = styled.div`
  padding-inline-end: 16px;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const Date = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  padding-block-start: 2px;
  color: ${(props) => props.theme.colors['neutral-90']};
`;

export const Description = styled.div`
  text-align: start;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-90']};
`;

export const AnswerButtons = styled.div`
  display: flex;
  margin: auto;
  column-gap: 8px;
  width: 100%;
  justify-content: flex-end;

  button {
    display: none;
  }
`;

export const ShowContentText = styled.span<{ $layout: PTORequestItemLayout }>`
  display: ${({ $layout }) => ($layout === 'wide' ? 'none' : 'inline-block')};
  font-size: 14px;
  line-height: 150%;
  padding-inline-end: 8px;
  color: ${(props) => props.theme.colors['primary-60']};
`;

export const Panel = styled.div``;
